// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1hZuK","col":"CardReaderDesc_col__1pkLk","label":"CardReaderDesc_label__3288M"};